import { background, reflection } from './renegades.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/230419/McLaren Miami 2023/renegades-le_mclarenmiami_{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'none',
  }),
}
